<div class="stability-dialog">
  <div class="stability-header">
    <button class="close-btn" mat-icon-button (click)="close()" aria-label="Close Stability 3.5 Info">
      <mat-icon>close</mat-icon>
    </button>

    <img src="assets/stability_dark.svg" alt="Stability 3.5 Logo" class="stability-logo" />
    <h2>Stability 3.5</h2>
    <span class="badge-optimal">High-Detail Images • Fast Generation • Prompt Precision</span>
  </div>

  <div class="stability-body">

    <p class="intro">
      <strong>Stability 3.5</strong> is a high-quality
      <span class="highlight">text-to-image generation model</span>
      built for crisp detail, strong composition, and fast creative iteration.
      It’s ideal for concept art, marketing visuals, thumbnails, and product-style imagery —
      especially when your prompt includes style, lighting, and scene details.
      <br /><br />
      <strong>Created by:</strong> <span class="highlight">Stability AI</span>
    </p>

    <ul class="qualities">
      <li>
        <span class="icon">✨</span>
        <span>
          <strong>Crisp Detail Output:</strong>
          Produces sharp textures, clean edges, and high-clarity images that hold up well for presentation.
        </span>
      </li>

      <li>
        <span class="icon">🎨</span>
        <span>
          <strong>Strong Style Range:</strong>
          Works well across photoreal, cinematic, illustration, 3D, anime, and stylized aesthetics.
        </span>
      </li>

      <li>
        <span class="icon">📐</span>
        <span>
          <strong>Composition & Prompt Control:</strong>
          Responds well to structured prompts that specify subject, environment, lighting, and camera framing.
        </span>
      </li>

      <li>
        <span class="icon">🧩</span>
        <span>
          <strong>Fast Variations:</strong>
          Great for generating multiple options quickly so you can pick a direction and refine.
        </span>
      </li>

      <li>
        <span class="icon">🖼️</span>
        <span>
          <strong>Useful for Production Assets:</strong>
          Great for mockups, marketing creatives, thumbnails, and early-stage concept art.
        </span>
      </li>

      <li>
        <span class="icon">✅</span>
        <span>
          <strong>Reliable Everyday Image Model:</strong>
          Balanced for quality + speed, making it a go-to choice for most image tasks.
        </span>
      </li>
    </ul>

    <div class="when-use">
      <h3>Why Users Choose Stability 3.5</h3>
      <ul>
        <li><strong>High-detail images</strong> for concepts, products, and marketing</li>
        <li><strong>Fast iteration</strong> when you want multiple options quickly</li>
        <li><strong>Prompt-driven control</strong> for style, lighting, and composition</li>
        <li><strong>Versatile aesthetics</strong> for both realistic and stylized visuals</li>
        <li><strong>Everyday reliability</strong> as the default image model</li>
      </ul>

      <div class="tip">
        <span>💡</span>
        <span>
          <strong>Pro Tip:</strong> Add lighting + lens cues:
          “soft rim light,” “cinematic contrast,” “35mm photo,” “shallow depth of field,” “ultra-detailed.”
        </span>
      </div>

      <div class="comparison">
        <h3>What Makes Stability 3.5 Feel “Crisp” in Real Use</h3>
        <p>
          Stability 3.5 feels crisp because it delivers strong detail and composition without needing heavy prompt engineering.
          Users typically notice:
        </p>
        <ul>
          <li>Sharper textures and cleaner edges</li>
          <li>Strong results from short prompts with style + lighting</li>
          <li>Consistent image quality across variations</li>
          <li>Fast creative iteration for real workflows</li>
        </ul>
      </div>
    </div>

  </div>
</div>
